module.exports = __webpack_public_path__ + "static/media/trotting.e4664871.svg";